var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcxLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_475_8567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7744 2.24318L23.535 10.4826C23.2104 10.8072 23.2104 11.3335 23.535 11.6581L28.3407 16.4638C28.6653 16.7884 29.1916 16.7884 29.5162 16.4638L37.7556 8.22439C38.0802 7.89979 38.0802 7.37352 37.7556 7.04892L32.9499 2.24319C32.6253 1.91859 32.099 1.91859 31.7744 2.24318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4834 23.5362L2.24399 31.7755C1.91939 32.1001 1.91939 32.6264 2.24399 32.951L7.04972 37.7568C7.37431 38.0813 7.90059 38.0813 8.22519 37.7567L16.4646 29.5174C16.7892 29.1928 16.7892 28.6665 16.4646 28.3419L11.6588 23.5362C11.3342 23.2116 10.808 23.2116 10.4834 23.5362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24318 8.22464L10.4826 16.464C10.8072 16.7886 11.3335 16.7886 11.658 16.464L16.4638 11.6583C16.7884 11.3337 16.7884 10.8074 16.4638 10.4828L8.22438 2.24343C7.89978 1.91883 7.3735 1.91883 7.0489 2.24343L2.24318 7.04917C1.91858 7.37377 1.91859 7.90005 2.24318 8.22464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5362 29.5176L31.7755 37.757C32.1001 38.0816 32.6264 38.0816 32.951 37.757L37.7567 32.9513C38.0813 32.6267 38.0813 32.1004 37.7567 31.7758L29.5173 23.5364C29.1927 23.2118 28.6665 23.2118 28.3419 23.5364L23.5362 28.3421C23.2116 28.6667 23.2116 29.193 23.5362 29.5176Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_475_8567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcxLogoIcon);
export default __webpack_public_path__ + "static/media/gcx-logo-icon.76d444c0910a97881755ec076013ae94.svg";
export { ForwardRef as ReactComponent };